import { gql } from '@common/hooks';

const OrganizationSettingQuery = gql`
  query OrganizationSetting {
    organizationSetting {
      id
      incentivePriceIncrements
      allowCustomIncentiveIncrements
      defaultIncentiveIncrement
      useDisputeClosing
      disputesDaysToClose
    }
  }
`;

export const UpdateOrganizationSettingMutation = gql`
  mutation UpdateOrganizationSettingMutation(
    $input: UpdateOrganizationSettingInput!
  ) {
    updateOrganizationSetting(input: $input) {
      organizationSetting {
        id
        useDisputeClosing
        disputesDaysToClose
      }
    }
  }
`;

export type OrganizationSettingResponse = {
  organizationSetting?: OrganizationSetting;
};

export type OrganizationSetting = {
  incentivePriceIncrements?: number;
  allowCustomIncentiveIncrements: boolean;
  defaultIncentiveIncrement: number;
  useDisputeClosing: boolean;
  disputesDaysToClose: number;
};

export { OrganizationSettingQuery };
